import * as Sentry from '@sentry/react';
import pako from 'pako';
import type { Bntrk } from '~/shared/bntrk';

const toBase64Url = (bytes: Uint8Array): string =>
  btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

const encode = (data: Bntrk): string | null => {
  try {
    const json = JSON.stringify(data);
    const compressed = pako.deflate(json);
    return toBase64Url(compressed);
  } catch {
    Sentry.captureException(new Error('Failed to encode Bntrk data'));
    return null;
  }
};

export default encode;
